export default __webpack_public_path__ + "static/media/S6BannerInsights.b706c0d9.png";